import makeLookupModal from "../../UI/LookupModal/LookupModal";
import PersonPopulationLookup from "./PersonPopulationLookup";
const PersonPopulationLookupModal = makeLookupModal(PersonPopulationLookup, {
    pluralEntityName: "Populations",
});
export default PersonPopulationLookupModal;
